import { Button, ButtonGroup, Modal } from '@veneer/core';
import { useState } from 'react';
import { ScreenInfo, useDataCollection } from '../../../jarvis/dataCollection';
import { sendFinishedEvent } from '../../../jarvis/eventService';

export type RetryCallback = () => void;

export type ModalErrorProps = {
  state: boolean;
  detail: ModalErrorDetail;
  screenInfo?: ScreenInfo;
};

export type ModalErrorDetail = {
  context: string;
  errorTitle?: string;
  errorMessage?: string;
  error?: Error;
  retryCallback?: RetryCallback;
};

const controlNameAcknowledgeButton = 'ErrorAcknowledgeButton';
const controlNameRetryButton = 'ErrorRetryButton';

function ModalError(props: ModalErrorProps) {
  const [showModal, setShowModal] = useState(props.state);
  const dataCollection = useDataCollection();
  const errorTitle = props.detail?.errorTitle ?? 'Something unexpected happened';
  const errorMessage = props.detail?.errorMessage ?? "We weren't able to resolve the issue.";

  // Showing error on console if theres an error stack on details
  if (props.detail?.error !== undefined) {
    console.log('Error:', props.detail.context, props.detail.error);
  }

  const onDismissTapped = () => onButtonTap(controlNameAcknowledgeButton, sendFinishedEvent);
  const onRetryTapped = () => onButtonTap(controlNameRetryButton, props.detail.retryCallback as RetryCallback);

  const onButtonTap = (controlName: string, action: () => void) => {
    console.log('ModalError::onButtonTap');
    const controlDetail = props.detail.error
      ? `${props.detail.context}: ${props.detail.error.message}`
      : props.detail.context;
    const controlInfo = {
      name: controlName,
      detail: controlDetail,
    };
    if (props.screenInfo) {
      dataCollection.sendControlClickedEvent(controlInfo, props.screenInfo);
    }
    setShowModal(false);
    action();
  };

  const dismissButton = (
    <Button onClick={onDismissTapped} appearance="primary">
      Dismiss
    </Button>
  );

  const retryButton = (
    <Button onClick={onRetryTapped} appearance="secondary">
      Retry
    </Button>
  );

  return (
    <>
      <Modal
        id="regular-modal"
        closeButton
        onClose={onDismissTapped}
        show={showModal}
        title={errorTitle}
        footer={
          <ButtonGroup>
            {props.detail?.retryCallback !== undefined ? retryButton : null}
            {dismissButton}
          </ButtonGroup>
        }
      >
        <p>{errorMessage} If you need further assistance, please contact us at HP.com/Support</p>
      </Modal>
    </>
  );
}

export default ModalError;
